<app-action-button
    (addEvent)="create()"
    [isDeleteAction]="isDeleteAction"
    (deleteEvent)="openConfirm($event)"
    [hidden]="!authorizationService.canCreateOIDCPublicClient()"
>
</app-action-button>

<app-loading-indicator [isLoading]="isLoading" class="load-indicator" *ngIf="isLoading" id="oidcAudiencesPage"></app-loading-indicator>
<div class="area data-table" id="ItemsArea">
    <app-noitems
        (clickEmit)="create()"
        [image]="'No_Clients'"
        [isEmpty]="showNoData"
        [typeName]="'oidc public clients.'"
    ></app-noitems>

    <app-data-table
        (filterChanged)="filterChanged.bind(this)"
        *ngIf="filterApplied || (oidcPublicClients.length > 0 && !isLoading) || filterHasChanged || changedPage"
        [columnDefinitions]="columnDefs"
        [columnFilters]="columnFilters"
        [rowData]="oidcPublicClients"
        [tableId]="'oidc-public-clients'"
        [toggleItem]="toggle.bind(this)"
        [toggleAll]="toggleAll.bind(this)"
        [deleteItem]="deleteSingleItem.bind(this)"
    ></app-data-table>
</div>
